import { render, staticRenderFns } from "./AccessWalletAddressNetwork.vue?vue&type=template&id=72f75d38&scoped=true&"
import script from "./AccessWalletAddressNetwork.vue?vue&type=script&lang=js&"
export * from "./AccessWalletAddressNetwork.vue?vue&type=script&lang=js&"
import style0 from "./AccessWalletAddressNetwork.vue?vue&type=style&index=0&id=72f75d38&lang=scss&scoped=true&"
import style1 from "./AccessWalletAddressNetwork.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f75d38",
  null
  
)

export default component.exports